<template functional>
  <div id="app" class="layout-public">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LayoutPublic",
  functional: true
};
</script>

<style lang="scss">
.layout-public {
  background-color: $color-white-smoke;
  height: 100vh;
  width: 100vw;
}
</style>
